import {
  MapPin,
  Users,
  Briefcase,
  Mail,
  Phone,
  Edit3,
  Globe,
} from "lucide-react";

const CompanyDetailModal = ({ company, onClose, onEdit }) => {
  if (!company) return null;
  const AWS = process.env.REACT_APP_AWS_HOST;

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title fw-bold">Company Details</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            {/* Company Header */}
            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-4">
              <img
                src={
                  company.logo
                    ? `${AWS}${company.logo}`
                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                        company.name
                      )}&background=random`
                }
                onError={(e) => {
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    company.name
                  )}&background=random`;
                }}
                alt={`${company.name} logo`}
                className="me-md-3 mb-3 mb-md-0 rounded"
                style={{ width: "80px", height: "80px", objectFit: "cover" }}
              />
              <div className="flex-grow-1">
                <h2 className="fw-bold text-dark mb-1">{company.name}</h2>
                <div className="d-flex align-items-center text-muted mb-2">
                  <MapPin size={18} className="me-2" />
                  <span className="fs-6">
                    {company.city}, {company.state}
                  </span>
                </div>
                <span
                  className={`badge fs-6 ${
                    company.status === "active"
                      ? "bg-success"
                      : "bg-secondary"
                  }`}
                >
                  {company.status.charAt(0).toUpperCase() +
                    company.status.slice(1)}
                </span>
              </div>
            </div>

            {/* Company Metrics */}
            <div className="row g-3 mb-4">
              <div className="col-12 col-md-4">
                <div className="bg-light p-3 rounded text-center h-100">
                  <Users size={18} className="mb-2 text-muted" />
                  <div className="fw-semibold text-dark">
                    {company.size}
                  </div>
                  <small className="text-muted">Employee Count</small>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="bg-light p-3 rounded text-center h-100">
                  <Briefcase size={18} className="mb-2 text-muted" />
                  <div className="fw-semibold text-dark">
                    {company.totalPosts}
                  </div>
                  <small className="text-muted">Total Posts</small>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="bg-light p-3 rounded text-center h-100">
                  <Users size={18} className="mb-2 text-muted" />
                  <div className="fw-semibold text-dark">
                    {company.totalHired}
                  </div>
                  <small className="text-muted">Total Hired</small>
                </div>
              </div>
            </div>

            {/* About Company */}
            <div className="mb-4">
              <h5 className="fw-bold mb-3">About Company</h5>
              <p className="text-muted lh-lg mb-0">{company.about}</p>
            </div>

            {/* Contact & Stats */}
            <div className="row">
              <div className="col-md-6 mb-4">
                <h6 className="fw-bold text-dark mb-3">
                  Contact Information
                </h6>
                <p className="mb-2">
                  <Mail size={16} className="me-2 text-muted" />
                  {company.contactEmail}
                </p>
                <p className="mb-2">
                  <Phone size={16} className="me-2 text-muted" />
                  {company.contactNumber}
                </p>
                <p className="mb-2">
                  <Users size={16} className="me-2 text-muted" />
                  {company.contactPerson}
                </p>
                <p className="mb-0">
                  <Globe size={16} className="me-2 text-muted" />
                  <a
                    href={company.website}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {company.website}
                  </a>
                </p>
              </div>

              <div className="col-md-6 mb-4">
                <h6 className="fw-bold text-dark mb-3">Company Stats</h6>
                <p className="mb-2">
                  <strong>Location:</strong>{" "}
                  <span className="text-muted">
                    {company.city}, {company.state}
                  </span>
                </p>
                <p className="mb-0">
                  <strong>Status:</strong>{" "}
                  <span
                    className={`badge ${
                      company.status === "active"
                        ? "bg-success"
                        : "bg-secondary"
                    } ms-2`}
                  >
                    {company.status.charAt(0).toUpperCase() +
                      company.status.slice(1)}
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer d-flex flex-column flex-md-row gap-2 justify-content-center">
            <button
              className="btn btn-primary w-50 d-flex align-items-center justify-content-center"
              onClick={() => onEdit(company)}
            >
              <Edit3 size={16} className="me-2" /> Edit Company
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDetailModal;
